import type { Me } from '@novachat/shared';
import { useLive } from '../state/live';
import { useVoice } from '../state/voice';
import { CallBar } from './CallBar';
import { useChannels } from './Sidebar';

/** Your call goes on while you read elsewhere: the green call bar on top, leading back to it. */
export function OngoingCall({ me }: { me: Me }) {
  const callId = useVoice((s) => (s.room ? s.channelId : null));
  const selected = useLive((s) => s.selectedChannelId);
  const { data: channels } = useChannels();
  const channel = channels?.find((c) => c.id === callId);
  if (!channel || selected === channel.id) return null;
  return <CallBar channel={channel} me={me} elsewhere onShowCall={() => useLive.getState().select(channel.id)} />;
}
